import { render, staticRenderFns } from "./PendingItem.vue?vue&type=template&id=be5944c6"
import script from "./PendingItem.vue?vue&type=script&lang=js"
export * from "./PendingItem.vue?vue&type=script&lang=js"
import style0 from "./PendingItem.vue?vue&type=style&index=0&id=be5944c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports